import { CreditDataMain } from "@/types/api/user/home.type.data";
import { numberSeparator,toPersianNumber } from "@/hooks/useThousandsSeparator";
import CustomTable from "@/shared/components/common/table";
import BoxKit from "@/shared/components/kit/box";
import CustomButton from "@/shared/components/kit/button";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { Grid } from "@mui/material";
import moment from "jalali-moment";
import React, { SetStateAction } from "react";
import { useNavigate } from "react-router";

type ContentProps = {
  setDetail?: React.Dispatch<SetStateAction<boolean>>;
  setEditDetail?: React.Dispatch<SetStateAction<boolean>>;
  userInquiry?: CreditDataMain;
};

/**
 * Content
 *
 * کامپوننت نمایش وضعیت اعتبارسنجی کاربر و جزئیات آن در جدول.
 * این کامپوننت شامل:
 * - نمایش تاریخ اعتبارسنجی و ارسال مدارک.
 * - نمایش وضعیت اعتبارسنجی، مبلغ اعتبار درخواستی و مدت بازپرداخت.
 * - دکمه مشاهده جزئیات برای فعال کردن نمایش جزئیات بیشتر.
 * - دکمه بازگشت به صفحه اصلی.
 *
 * @param {Object} props
 * @param {React.Dispatch<SetStateAction<boolean>>} [props.setDetail] تابع برای نمایش جزئیات
 * @param {React.Dispatch<SetStateAction<boolean>>} [props.setEditDetail] تابع برای فعال کردن ویرایش جزئیات
 * @param {CreditDataMain} [props.userInquiry] داده‌های اعتبار کاربر
 *
 * @component
 * @returns JSX.Element
 */

const Content = (props: ContentProps) => {
  const navigate = useNavigate();
  // const [enabledReset, setEnabledReset] = useState(false);
  const { setDetail, setEditDetail, userInquiry } = props;

  const handleClick = () => {
    if (setDetail && setEditDetail) {
      setDetail(true);
      setEditDetail(true);
    }
  };

  const dataHeader = [
    { id: "validation_credit", title: "تاریخ استعلام اعتبارسنجی" },
    { id: "send_docs_at", title: "تاریخ ارسال مدارک" },
    { id: "status_manager_answer", title: "وضعیت اعتبار سنجی" },
    { id: "price", title: "مبلغ اعتبار درخواستی" },
    { id: "month", title: "مدت بازپرداخت" },
  ];
  const newData = {
    id: userInquiry?.id,
    validation_credit: userInquiry?.validation_credit ? toPersianNumber(moment(userInquiry?.validation_credit).locale("fa").format("YYYY/MM/DD")) : "-",
    send_docs_at: userInquiry?.send_docs_at ? toPersianNumber(moment(userInquiry?.send_docs_at).locale("fa").format("YYYY/MM/DD")) : "-",
    status_manager_answer: userInquiry?.status_manager_answer === "await_admin" ? "در انتظار تایید مدارک" : "درحال بررسی",
    price: `${numberSeparator(userInquiry?.price)} ریال`,
    month: toPersianNumber(`${userInquiry?.month}`),
  };

  const handleClickReset = () => {
    navigate("/");

    window.location.reload();
  };
  const fakeData = [newData];

  return (
    <Grid sx={{ height: "100%", display: "flex", flexDirection: "column", padding: "1rem", gap: 3,}}>
      {/* Header Info */}
      <StackKit sx={{ width: "100%", alignItems: "flex-start" }} spacing={2}>
        <TypoGraphyKit variant="h6">
          وضعیت اعتبار سنجی: در انتظار ادمین
        </TypoGraphyKit>
        <TypoGraphyKit variant="body1">جزئیات اعتبار سنجی:</TypoGraphyKit>

        {/* Table + Button Row */}
        <StackKit direction={{ md: "column", lg: "row" }} gap={3} justifyContent="flex-start" alignItems={{ xs: "stretch", md: "baseline" }} sx={{ width: "100%" }}>
          {/* Table */}
          <BoxKit sx={{ width: { md: "100%", lg: "75%" }, overflowX: "auto" }}>
            <CustomTable dataHeader={dataHeader} dataTbody={fakeData} />
          </BoxKit>

          {/* Button Box */}
          <BoxKit className="flex flex-col items-center justify-center " sx={{ width: { md: "100%", lg: "150px" }, gap: 2,}}>
            <TypoGraphyKit sx={{ color: "#767676" }} variant="body1"/>
            <CustomButton sx={{ width: "100%" }} onClick={handleClick}>
              مشاهده جزئیات
            </CustomButton>
          </BoxKit>
        </StackKit>
      </StackKit>

      {/* Bottom Button */}
      <StackKit direction="row" justifyContent={{ xs:'center' , sm:'center' , md: "center", lg: "flex-end" }}>
        <CustomButton onClick={handleClickReset}>صفحه اصلی</CustomButton>
      </StackKit>
    </Grid>
  );
};

export default Content;
